import {useSelector} from "react-redux";
import React from "react";
import {getCommentSummary} from "../../../../../api/commentAPI";
import styles from "./sections.module.css";
import Loading from "../../../../General/loading/loading";
import {updateSummaryAPI} from "../../../../../api/reviewsAPI";
import {getDocketTopicsAPI} from "../../../../../api/docketAPI";

const getNonRiderTopics = async (jwt, docket, selectedTopics) => {

    let allTopicsResp = await getDocketTopicsAPI(jwt, docket)

    let nonRiderTopics = {}

    for (let topicKey of Object.keys(selectedTopics)) {

        if (!(allTopicsResp[topicKey].isRider)) {
            nonRiderTopics[topicKey] = selectedTopics[topicKey]
        }
    }

    return nonRiderTopics
}


const Summary = ({trackingNumber, topics, updateSavedState, isPaused}) => {

    const jwt = useSelector((state) => state.user.jwt);
    const docket = useSelector((state) => state.navigation.currentDocket);

    const [topicFilter, setTopicFilter] = React.useState("")

    const [summaryText, setSummaryText] = React.useState("")
    const [summaryLoading, setSummaryLoading] = React.useState(false)
    const [shouldSaveSummary, setShouldSaveSummary] = React.useState(false);

    const [summaryTopics, setSummaryTopics] = React.useState({})

    const updateSummaryText = (text) => {
        setShouldSaveSummary(true)
        setSummaryText(text)
        updateSavedState(false)
    }

    React.useEffect(() => {
        if (topicFilter === "") {
            setSummaryText("")
        } else {
            let topicSubtopicSplit = topicFilter.split("||")
            setSummaryLoading(true)
            getCommentSummary(jwt, docket, trackingNumber, topicSubtopicSplit[0], topicSubtopicSplit[1]).then(r => {
                setSummaryLoading(false)
                setSummaryText(r)
                setShouldSaveSummary(false)
            })
        }
    }, [topicFilter])

    React.useEffect(() => {
        setTopicFilter("")
        setSummaryLoading(false)
        setSummaryText("")
    }, [trackingNumber])

    React.useEffect(() => {
        getNonRiderTopics(jwt, docket, topics).then(r => setSummaryTopics(r))
    }, [jwt, docket, topics])

    React.useEffect(() => {
        if (!shouldSaveSummary) {
            return () => {
            }
        }

        let timeoutID = setTimeout(() => {
            let topicSubtopicSplit = topicFilter.split("||")
            updateSummaryAPI(jwt, docket, trackingNumber, summaryText, topicSubtopicSplit[0], topicSubtopicSplit[1]).then(r => {
                if (r.success) {
                    updateSavedState(true)
                }
            })
        }, 750)

        return () => {
            clearTimeout(timeoutID)
        }
    }, [summaryText, shouldSaveSummary])

    return (
        <div className={styles.wrapperFlexCenter}>
            <select className={styles.dropdown} aria-label={"Summary Topic Select"} value={topicFilter}
                    onChange={(event) => setTopicFilter(event.currentTarget.value)}>
                <option value={""}>-- Select --</option>
                {
                    Object.keys(summaryTopics).map(topic => (
                        <React.Fragment key={`${topic}||`}>
                            <option value={`${topic}||`}>{topic}</option>
                            {
                                Object.keys(summaryTopics[topic]['children']).map(subtopic => (
                                    <option key={`${topic}||${subtopic}`}
                                            value={`${topic}||${subtopic}`}>{topic} || {subtopic}</option>
                                ))
                            }
                        </React.Fragment>
                    ))
                }
            </select>
            {
                summaryLoading ? <Loading/> :
                    <textarea disabled={isPaused || topicFilter === ""} className={styles.textArea} value={summaryText}
                              onChange={e => updateSummaryText(e.currentTarget.value)}/>
            }
        </div>
    )
}

export default Summary